// src/components/molecules/landing/faq-item.tsx
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export type FaqEntry = {
  id: string;
  index: string;
  question: string;
  answer: string;
  category: string;
};

export function FaqItem({ entry }: { entry: FaqEntry }) {
  return (
    <AccordionItem
      value={entry.id}
      className="overflow-hidden rounded-2xl border border-brand-border bg-white px-5 last:border-b"
    >
      <AccordionTrigger className="items-center gap-4 py-7 text-left hover:no-underline">
        <span className="flex items-center gap-4">
          <span
            aria-hidden
            className="text-sm font-semibold text-brand"
          >
            {entry.index}
          </span>
          <span className="text-base font-semibold text-brand-ink sm:text-lg">
            {entry.question}
          </span>
        </span>
      </AccordionTrigger>
      <AccordionContent className="pb-5 pl-10 text-sm text-brand-ink/70 sm:text-base">
        {entry.answer}
      </AccordionContent>
    </AccordionItem>
  );
}
